/*
	validator.js is used to validate all fields in any forms
	https://validatejs.org/#validators for all validations.
*/
export const fieldNames = {
  name: 'name',
  email: 'email',
  message: 'message',
};

export default {
  [fieldNames.name]: {
    presence: true,
  },
  [fieldNames.email]: {
    presence: true,
    email: true,
  },
  [fieldNames.message]: {
    presence: true,
  },
};



// WEBPACK FOOTER //
// ./src/ui/graphql/ContactMessage/model.js